import LeftArrowIcon from '@assets/icons/arrow-left.svg?react'
import HeaderSteps from '@components/HeaderSteps'
import { breakpoints } from '@constants'
import { useFeatureFlag } from '@hooks'
import { pathPatternToRegex } from '@utils'
import { CounterpartyPageHeader } from '@views/counterparty/elements/CounterpartyPageHeader'
import { CounterpartyViewHeader } from '@views/counterparty/elements/CounterpartyViewHeader'
import { ReportActionsHeader, ReportHeader } from '@views/expenseManagement'
import { ExpenseManagementTooltip } from '@views/expenseManagement/@elements/ExpenseManagementTooltip'
import { InvoiceActions } from '@views/invoices/InvoiceActions'
import { RecipientDetailsHeader } from '@views/recipients/RecipientDetailsPage/RecipientDetailsHeader'
import { CreateMatrixButton } from '@views/userDepartmantManagement/CreateMatixButton/CreateMatrixButton'
import { CustomApprovalMatrixDropdown } from '@views/userDepartmantManagement/CustomApprovalMatrixDropdown'
import { paths } from 'mmfintech-backend-api'
import { tr, useMatchMedia } from 'mmfintech-commons'
import { useHistory, useLocation } from 'react-router-dom'
import { DashboardFeeDiscountToggle } from './DashboardFeeDiscountToggle'
import { WelcomeTitle } from './Welcome'

export const CustomHeaderTitles = () => {
  const isLarge = useMatchMedia({ breakpoint: breakpoints.xl, prefix: 'max' })

  const location = useLocation()
  const history = useHistory()

  const hasTransactionApprovalFlow = useFeatureFlag('transactionApprovalFlow')

  const parts = location?.pathname?.split('/') // Split the string by '/'
  const param = parts?.[parts?.length - 1] || '' // Get the last part
  const successTransactionParam = parts?.[parts?.length - 2] || ''

  if (location?.pathname === paths.banking.sendBatchPayment()) {
    return (
      <div className='step-container'>
        <div className='step-left-side'>
          <div
            onClick={e => {
              e?.preventDefault()
              history.goBack()
            }}
            className='back-arrow-icon'
          >
            <LeftArrowIcon />
          </div>
          <div className='title-wrapper'>
            <span className='title'>{tr('FRONTEND.HEADER.BATCH_PAYMENT', 'Batch payment')}</span>
          </div>
        </div>
        <HeaderSteps />
      </div>
    )
  }

  if (pathPatternToRegex(`${paths.banking.send()}/*`).test(location?.pathname)) {
    return (
      <div className='step-container'>
        <div className='step-left-side'>
          <div
            onClick={e => {
              e?.preventDefault()
              history.push(paths.dashboard())
            }}
            className='back-arrow-icon'
          >
            <LeftArrowIcon />
          </div>
          <div className='title-wrapper'>
            <span className='title'>{tr('FRONTEND.HEADER.SEND_MONEY', 'Send')}</span>
          </div>
        </div>
        <HeaderSteps />
      </div>
    )
  }

  switch (location?.pathname) {
    case '/profile/security':
    case '/profile/details':
    case '/profile/notifications':
      return (
        !isLarge && (
          <div className='header-title-wrapper'>
            <span className='title'>{tr('FRONTEND.HEADER.PROFILE_SETTINGS', 'Profile settings')}</span>
          </div>
        )
      )

    case paths.onboarding.questionnaireKyb():
      return (
        <div className='step-container'>
          <div className='step-left-side'>
            <div
              onClick={e => {
                e.preventDefault()
                window?.history.back()
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>
            <span className='title'>{tr('FRONTEND.HEADER.QUESTIONNAIRE', 'KYB-Questionnaire')}</span>
          </div>
          <HeaderSteps />
        </div>
      )

    case paths.banking.deposit():
    case paths.banking.depositPreview():
      return (
        <div className='step-container'>
          <div className='step-left-side'>
            <div
              onClick={e => {
                e.preventDefault()
                window.history.back()
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>
            <div className='title-wrapper'>
              <span className='title'>{tr('FRONTEND.HEADER.DEPOSIT', 'Deposit')}</span>
            </div>
          </div>
          <HeaderSteps />
        </div>
      )

    case paths.more.cashVoucher('buy'):
    case paths.more.cashVoucher('redeem'):
    case paths.more.cashVoucher('list'):
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.KINGDOM_CASH', 'Kingdom Cash')}</span>
          {!isLarge && (
            <span className='sub-title'>
              {tr('FRONTEND.HEADER.KINGDOM_CASH_SUBTITLE', 'Buy new and redeem your vouchers.')}
            </span>
          )}
        </div>
      )

    case paths.banking.accounts.list():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.ACCOUNTS', 'Accounts')}</span>
          {!isLarge && (
            <span className='sub-title'>{tr('FRONTEND.HEADER.ACCOUNTS_SUBTITLE', 'Manage your accounts')}</span>
          )}
        </div>
      )

    case paths.recipients.list():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.RECIPIENTS', 'Recipients')}</span>
          {!isLarge && (
            <span className='sub-title'>{tr('FRONTEND.HEADER.RECIPIENTS_SUBTITLE', 'Manage your recipients')}</span>
          )}
        </div>
      )
    case paths.recipients.details(param):
      return (
        <div className='header-title-wrapper'>
          <RecipientDetailsHeader param={param} />
        </div>
      )

    case paths.more.savings():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.SAVINGS', 'Savings')}</span>
          {!isLarge && (
            <span className='sub-title'>{tr('FRONTEND.HEADER.SAVINGS_SUBTITLE', 'Deposit any free funds.')}</span>
          )}
        </div>
      )

    case paths.banking.exchange():
      return (
        <div className='step-container'>
          <div className='step-left-side'>
            <div
              onClick={e => {
                e.preventDefault()
                window.history.back()
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>
            <div className='title-wrapper'>
              <span className='title'>{tr('FRONTEND.HEADER.EXCHANGE', 'Exchange')}</span>
            </div>
          </div>
          <HeaderSteps />
        </div>
      )

    // case paths.banking.send():
    // case paths.banking.sendPix():
    // case paths.banking.sendToCard():
    // case paths.banking.sendInterac():
    // case paths.banking.sendPerfectMoney():
    // case paths.banking.sendDigitalWallet():
    // case paths.banking.sendToLinkedAccount():
    // case paths.banking.sendInternalTransfer():
    // case paths.banking.sendIntraAccountTransfer():
    // case paths.banking.sendTo(':recipientId'):
    // case paths.banking.sendBankTransfer():
    // case paths.banking.sendCrypto():
    // case paths.banking.sendSkrill():
    //   return (
    //     <div className='step-container'>
    //       <div className='step-left-side'>
    //         <div
    //           onClick={e => {
    //             e?.preventDefault()
    //             history.push(paths.dashboard())
    //           }}
    //           className='back-arrow-icon'
    //         >
    //           <LeftArrowIcon />
    //         </div>
    //         <div className='title-wrapper'>
    //           <span className='title'>{tr('FRONTEND.LAYOUT.HEADER.SEND_MONEY', 'Send')}</span>
    //         </div>
    //       </div>
    //       <HeaderStepComponent />
    //     </div>
    //   )

    // case paths.banking.sendBatchPayment():
    //   return (
    //     <div className='step-container'>
    //       <div className='step-left-side'>
    //         <div
    //           onClick={e => {
    //             e?.preventDefault()
    //             history.push(paths.dashboard())
    //           }}
    //           className='back-arrow-icon'
    //         >
    //           <LeftArrowIcon />
    //         </div>
    //         <div className='title-wrapper'>
    //           <span className='title'>{tr('FRONTEND.LAYOUT.HEADER.BATCH_PAYMENT', 'Batch payment')}</span>
    //         </div>
    //       </div>
    //       <HeaderStepComponent />
    //     </div>
    //   )

    case paths.invoices.create():
    case paths.invoices.upload():
    case paths.invoices.uploadEdit(param):
    case paths.invoices.add():
      return (
        <div className='step-container'>
          <div className='step-left-side'>
            <div
              onClick={e => {
                e?.preventDefault()
                window.history.back()
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>
            <div className='title-wrapper'>
              <span className='title'>{tr('FRONTEND.HEADER.INVOICE_NEW', 'Create invoice')}</span>
            </div>
          </div>
          <HeaderSteps />
        </div>
      )
    case paths.invoices.send(param):
      return (
        <div className='step-container'>
          <div className='step-left-side'>
            <div
              onClick={e => {
                e?.preventDefault()
                window.history.back()
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>
            <div className='title-wrapper'>
              <span className='title'>{tr('FRONTEND.HEADER.INVOICE_DETAILS', 'Invoice details')}</span>
            </div>
          </div>
          <HeaderSteps />
        </div>
      )
    case paths.invoices.edit(param):
      return (
        <div className='step-container'>
          <div className='step-left-side'>
            <div
              onClick={e => {
                e?.preventDefault()
                window.history.back()
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>
            <div className='title-wrapper'>
              <span className='title'>{tr('FRONTEND.HEADER.INVOICE_EDIT', 'Edit invoice')}</span>
            </div>
          </div>
          <HeaderSteps />
        </div>
      )
    case paths.invoicesCustomersWrapper() + paths.invoices.list():
    case paths.invoicesCustomersWrapper() + paths.customers():
      return (
        <div className='step-container invoice-customers-steps'>
          <div className='step-left-side'>
            <div className='title-wrapper'>
              <span className='title'>{tr('FRONTEND.HEADER.INVOICES', 'Invoices')}</span>
              {!isLarge && (
                <span className='sub-title'>{tr('FRONTEND.HEADER.INVOICES_SUBTITLE', 'Manage your invoices')}</span>
              )}
            </div>
          </div>
          <InvoiceActions />
        </div>
      )

    case paths.banking.transactions.list():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.TRANSACTIONS', 'Transactions')}</span>
          {!isLarge && (
            <span className='sub-title'>{tr('FRONTEND.HEADER.TRANSACTIONS_SUBTITLE', 'Check all your movements')}</span>
          )}
        </div>
      )

    case paths.referralProgram():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.REFERRAL', 'Invite & Earn')}</span>
          {!isLarge && (
            <span className='sub-title'>{tr('FRONTEND.HEADER.REFERRAL_SUBTITLE', 'Check on your referrals.')}</span>
          )}
        </div>
      )

    case paths.cards.cardList():
    case paths.cards.cardLink():
    case paths.cards.cardOrder():
      return (
        <div className='cards-header'>
          <div className='header-title-wrapper'>
            <span className='title'>{tr('FRONTEND.HEADER.CARDS', 'Cards')}</span>
            {!isLarge && (
              <span className='sub-title'>{tr('FRONTEND.HEADER.CARDS_SUBTITLE', 'Check on your cards.')}</span>
            )}
          </div>
        </div>
      )

    case paths.developer():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.DEVELOPERS', 'Developers')}</span>
        </div>
      )

    case paths.userManagement():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.USER_MANAGEMENT', 'User management')}</span>
        </div>
      )

    case paths.ibanIssuing():
    case paths.ibanIssuingPreview():
      return (
        <div className='step-container'>
          <div className='step-left-side'>
            <div
              onClick={e => {
                e?.preventDefault()
                window.history.back()
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>
            <div className='title-wrapper'>
              <span className='title'>{tr('FRONTEND.HEADER.IBAN', 'IBAN issuing')}</span>
              {!isLarge && (
                <span className='sub-title'>{tr('FRONTEND.HEADER.IBAN_SUBTITLE', 'Obtain a dedicated IBAN.')}</span>
              )}
            </div>
          </div>
          <HeaderSteps />
        </div>
      )

    case paths.expenseManagement.dashboard():
    case paths.expenseManagement.reports():
      return (
        <div className='step-container expenses-steps'>
          <div className='step-left-side'>
            <div className='title-wrapper'>
              <span className='title'>
                {tr('FRONTEND.HEADER.EXPENSE_REPORTS', 'Expense reports')}
                <ExpenseManagementTooltip />
              </span>
              {!isLarge && (
                <span className='sub-title'>
                  {tr('FRONTEND.HEADER.EXPENSE_REPORTS_SUBTITLE', 'Control what you spend.')}
                </span>
              )}
            </div>
          </div>
          <ReportActionsHeader />
        </div>
      )

    case paths.expenseManagement.reportDetails(param):
      return (
        <div className='step-container expenses-steps'>
          <ReportHeader param={param} />
        </div>
      )

    case paths.expenseManagement.payments(param):
      return (
        <div className='step-container'>
          <ReportHeader param={param} />
        </div>
      )

    case paths.expenseManagement.counterparties():
      return (
        <div className='step-container expenses-steps'>
          <div className='step-left-side'>
            <span className='title'>{tr('FRONTEND.HEADER.COUNTERPARTY', 'Counterparties')}</span>
          </div>
          <CounterpartyViewHeader />
        </div>
      )

    case paths.expenseManagement.counterpartyDetails(param):
      return (
        <div className='step-container'>
          <CounterpartyPageHeader counterpartyId={param} />
        </div>
      )

    case paths.userDepartmentManagement():
    case `${paths.userDepartmentManagement()}/users`:
    case `${paths.userDepartmentManagement()}/departments`:
      return (
        <div className='step-container expenses-steps user-department-steps'>
          <div className='step-left-side'>
            <span className='title'>{tr('FRONTEND.HEADER.DEPARTMENT_MANAGEMENT', 'User & Department management')}</span>
          </div>
          {hasTransactionApprovalFlow ? <CustomApprovalMatrixDropdown /> : <CreateMatrixButton />}
        </div>
      )

    case paths.scanAndPay():
    case paths.p2pQrCode():
      return (
        <div className='step-container'>
          <div className='step-left-side'>
            <div
              onClick={e => {
                e?.preventDefault()
                history.push(paths.dashboard())
              }}
              className='back-arrow-icon'
            >
              <LeftArrowIcon />
            </div>
            <div className='title-wrapper'>
              <span className='title'>{tr('FRONTEND.HEADER.SCAN_AND_PAY', 'Scan & Pay')}</span>
            </div>
          </div>
        </div>
      )

    case paths.banking.finalStatus.success(successTransactionParam):
    case paths.banking.finalStatus.fail(successTransactionParam):
      return <div />

    case paths.overdraft():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.OVERDRAFT', 'Overdraft')}</span>
          {!isLarge && (
            <span className='sub-title'>
              {tr('FRONTEND.HEADER.OVERDRAFT_SUBTITLE', 'Get more funds when you need them most.')}
            </span>
          )}
        </div>
      )

    case paths.crypto.root():
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.CRYPTO', 'Crypto')}</span>
          {!isLarge && (
            <span className='sub-title'>
              {tr('FRONTEND.HEADER.CRYPTO_SUBTITLE', 'Buy, sell and checkout the crypto market')}
            </span>
          )}
        </div>
      )

    case paths.support.tickets():
    case paths.support.ticketDetail(param):
      return (
        <div className='header-title-wrapper'>
          <span className='title'>{tr('FRONTEND.HEADER.SUPPORT', 'Customer support')}</span>
          {!isLarge && (
            <span className='sub-title'>
              {tr('FRONTEND.HEADER.SUPPORT_SUBTITLE', 'View and manage your support requests')}
            </span>
          )}
        </div>
      )

    default:
      return (
        <div className='header-title-wrapper dashboard-title-wrapper'>
          <div className='header-title-text'>
            <WelcomeTitle />
            <span className='sub-title'>
              {tr('FRONTEND.HEADER.OVERVIEW_SUBTITLE', 'Check out your recent financial activity')}
            </span>
          </div>
          <DashboardFeeDiscountToggle />
        </div>
      )
  }
}
